import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import rootReducer from "./store/reducers";
import { Router } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core";
import THEME from "./utils/theme";
import { MAP_BOUNDS, MAP_HOVER_STOP } from "./store/actions/types";
import "./utils/localization";
import history from "./utils/history";
import * as Sentry from "@sentry/react";
// import { Integrations } from "@sentry/tracing";
import { version } from "../package.json";
// import UnderConstructionScreen from "./underConstruction/UnderConstructionScreen";

// Sentry — same account/org (routetitan-rr) as fojw-api and fojw-dwa.
// Errors only: no BrowserTracing / tracesSampleRate, to stay within the sentry.io
// free-tier transaction quota. release + environment tag every event; user is
// attached via Sentry.setUser on login (see Dashboard.js).
// Deployed builds only — NODE_ENV is "production" in every react-scripts build
// (stag + prod), so local `npm start` does not report to Sentry.
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://1b876b5bebbb916ef68e32bc646e8024@o4511133972299776.ingest.de.sentry.io/4511535330099280",
    environment: process.env.REACT_APP_ENVIRONMENT,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    release: version,
    ignoreErrors: [/Request failed with status code 4\d\d/]
  });
}

export const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== "production"
      ? window.__REDUX_DEVTOOLS_EXTENSION__({
          actionsBlacklist: [MAP_HOVER_STOP, MAP_BOUNDS],
          trace: true,
          traceLimit: 25
        })
      : f => f
  )
);

if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot remove a child from a different parent",
          child,
          this
        );
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (console) {
        console.error(
          "Cannot insert before a reference node from a different parent",
          referenceNode,
          this
        );
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

ReactDOM.render(
  <MuiThemeProvider theme={THEME}>
    <Provider store={store}>
      <Router history={history}>
        <App />
        {/* <UnderConstructionScreen /> */}
      </Router>
    </Provider>
  </MuiThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
